import { useEffect, useState } from 'react'

export const useScreenSizeListener = () => {
  const [currentWidth, setCurrentWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1280)

  useEffect(() => {
    if (typeof window === 'undefined') return

    setCurrentWidth(window.innerWidth)
    const handleResize = () => {
      setCurrentWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    isMobile: currentWidth <= 1280,
    isDesktop: currentWidth > 1280,
  }
}
